import { Box, Center, Flex, Icon, Image, Spinner, Text } from '@chakra-ui/react';
import { FiCamera } from '@react-icons/all-files/fi/FiCamera';
import { FiCheck } from '@react-icons/all-files/fi/FiCheck';

type ShotTileProps = {
  label: string;
  hint: string;
  previewUrl?: string;
  isUploading: boolean;
  disabled: boolean;
  onTap: () => void;
};

const ShotTile = ({ label, hint, previewUrl, isUploading, disabled, onTap }: ShotTileProps) => {
  const tappable = !disabled;
  return (
    <Flex
      as="button"
      type="button"
      disabled={disabled}
      direction="column"
      onClick={tappable ? onTap : undefined}
      borderRadius="12px"
      borderWidth="1px"
      borderStyle={previewUrl ? 'solid' : 'dashed'}
      borderColor={previewUrl ? 'leaseEndGreen' : 'platinum'}
      bg="white"
      overflow="hidden"
      textAlign="left"
      cursor={tappable ? 'pointer' : 'default'}
      _hover={tappable ? { borderColor: 'leaseEndBlue' } : undefined}
    >
      {previewUrl ? (
        <Box position="relative" w="100%">
          <Image src={previewUrl} alt={label} w="100%" h="96px" objectFit="cover" />
          <Flex
            position="absolute"
            top="6px"
            right="6px"
            w="22px"
            h="22px"
            borderRadius="full"
            align="center"
            justify="center"
            bg="leaseEndGreen"
            color="white"
          >
            {isUploading ? <Spinner size="xs" /> : <Icon as={FiCheck} boxSize="13px" />}
          </Flex>
        </Box>
      ) : (
        <Center w="100%" h="96px" bg="grayLightest" color="grayMedium">
          {isUploading ? (
            <Spinner size="sm" color="leaseEndBlue" />
          ) : (
            <Icon as={FiCamera} boxSize="22px" />
          )}
        </Center>
      )}
      <Box px="10px" py="8px">
        <Text fontSize="13px" fontWeight={700} color="charcoal">
          {label}
        </Text>
        <Text fontSize="11px" lineHeight="1.4" color="grayMedium">
          {hint}
        </Text>
      </Box>
    </Flex>
  );
};

export default ShotTile;
